module.exports = {
	"general": {
		"title": "Hello, I’m Kolin Weidmann,<br> freelance front-end developer based in Paris.",
		"description": "# HTML, CSS, JS <br><small>&angrt; Vue.js, Shopify, Prismic, DatoCMS, Wordpress, NPM, Yarn, Webpack, Git, Figma ...</small><br><br><a href=\"mailto:kolin.w@gmail.com\">Get in touch</a>"
	},
	"titles": {
		"top": "TL;DR",
		"projects": "Projects",
		"archives": "Archives",
		"about": "About"
	},
	"projects": [
		{
			"id": "openspaceparis",
			"title": "Open&nbsp;Space&nbsp;Paris",
			"description": "Talent management agency portfolio of portfolios, continuously updated with lots of high quality pictures of their artists. <br> <small>Design and development for <a href=\"https://athom.co/\" target=\"_blank\">Athom</a></small>",
			"live": true,
			"url": "https://openspaceparis.com"
		},
		{
			"id": "miles",
			"title": "Miles",
			"description": "Portfolio for the creative & independent Paris based production company Miles. <br> <small>Design by <a href=\"http://kevinlagier.com/\" target=\"_blank\">Kevin Lagier</a></small> ",
			"live": true,
			"url": "https://miles.tv"
		},
		{
			"id": "obachan",
			"title": "obachan",
			"description": "Minimalist webshop build on Shopify for the best traditional Japanese products handpicked by <a href=\"http://eien.tokyo/\" target=\"_blank\">Michele Angeloro</a><br> <small>Design by <a href=\"http://eien.tokyo/\" target=\"_blank\">Michele Angeloro</a></small> ",
			"extra": "Awwwards - Site of the Day 28/02/2019 <br> Awwwards - Developer Award & Mobile Excellence 07/02/2019",
			"live": true,
			"url": "https://getobachan.com"
		},
		{
			"id": "jason",
			"title": "Jason&nbsp;Yan&nbsp;Francis",
			"description": "Jason is a young and talented director, with a flashy new portfolio. <br> <small>Design by Jason</small> ",
			"extra": "CSSDSGN - 16/01/2018 <br> French Design Index - Site of the day 04/03/2018",
			"live": false
		},
		{
			"id": "protest",
			"title": "Protest",
			"description": "Multilingual e-commerce and brand website for the sportswear brand.<br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "Awwwards - Site of the year - E-commerce 2016<br> Awwwards - Site of the day 08/12/2016 <br> CSSDA - Website of the day 10/12/2016",
			"live": true,
			"url": "http://protest.eu"
		},
		{
			"id": "etqstore",
			"title": "ETQ&nbsp;Store",
			"description": "Online multibrand store for the Amsterdam flagship store of ETQ <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "Siteinspire",
			"live": true,
			"url": "https://www.etqstore.com/"
		}
	],
	"archives": [
		{
			"id": "lechemiseur",
			"title": "Le Chemiseur",
			"description": "New version of the shirt configurator app inside the webshop, allowing you to generate and modify all your measurements before ordering. <br> <small>UI and Development for <a href=\"https://athom.co/\" target=\"_blank\">Athom</a></small>",
			"live": true,
			"url": "https://lechemiseur.fr/"
		},
		{
			"id": "ag2r-triss",
			"title": "AG2R Trophées Régionaux des Initiatives Sociales et Solidaires",
			"description": "Application form and showcase for a Social and Solidarity Economy grant <br> <small>UX, UI and Development for <a href=\"https://athom.co/\" target=\"_blank\">Athom</a></small>",
			"live": true,
			"url": "https://www.initiative-sociale.ag2rlamondiale.fr/"
		},
		{
			"id": "desperados",
			"title": "Desperados FuturEdition",
			"description": "Promotion website for Desperados limited edition bottle on which the label is the gateway to an artistic experience mixing AR and VR<br> <small>Built at <a href=\"https://www.mnstr.com/en/\" target=\"_blank\">MNSTR</a></small>",
			"extra": "",
			"live": false
		},
		{
			"id": "cantorfineart",
			"title": "Cantor&nbsp;Fine&nbsp;Art",
			"description": "Los Angeles based art gallery e-commerce <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"live": false,
			"extra": "Awwwards - Site of the day 31/05/2016 <br> CSSDA - Website of the day 02/06/2016"
		},
		{
			"id": "cultcheers",
			"title": "Cultcheers",
			"description": "Colorful landing page for this startup launching a new concept of informal cultural meetups at home. <br> <small>Built for <a href=\"https://pantographe.studio/en\">Pantographe</a>, design by <a href=\"https://www.behance.net/marinesergent\" target=\"_blank\">Marine Sergent</a> </small>",
			"live": false
		},
		{
			"id": "upcraft",
			"title": "Upcraft",
			"description": "Upcraft is an innovative upcycling brand that transforms high quality surplus materials from diverse industries into stylish design accessories. <br> <small>Design by <a href=\"https://www.michaelspeichert.com\" target=\"_blank\">Michael Speichert</a> </small>",
			"extra": "Mindsparkle",
			"live": true,
			"url": "http://upcraft.de"
		},
		{
			"id": "amsterdamevenements",
			"title": "Amsterdam Évènements",
			"description": "Multilingual showcase site for the Amsterdam based event planning company. <br> <small>Design by <a href=\"https://www.behance.net/marinesergent\" target=\"_blank\">Marine Sergent</a> </small>",
			"live": true,
			"url": "http://www.amsterdamevenements.com"
		},
		{
			"id": "newfysic",
			"title": "Newfysic",
			"description": "Dashboard application and brand/e-commerce website for the slimming method clients. <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "",
			"live": false
		},
		{
			"title": "Michel Weidmann",
			"description": "Portfolio for my father who's working as sculptor for the entertainment industry. <br> <small>Personnal project</small>",
			"live": true,
			"url": "http://michelweidmann.fr/"
		},
		{
			"id": "cloudfaves",
			"title": "Cloudfaves",
			"description": "Enhanced soundcloud player. <br> <small>Personnal project</small>",
			"live": false
		},
		{
			"id": "sparked",
			"title": "Sparked",
			"description": "Responsive business to business platform. <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"extra": "Awwwards - Site of the day 13/05/2016 <br> Awwwards - Developer site of the day 13/05/2016 <br> CSSDA - Website of the day 03/04/2016",
			"live": false,
			"no_details": true
		},
		{
			"id": "high45",
			"title": "HIGH45",
			"description": "High intensity interval training boutique based in Amsterdam. <br> <small>Built at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a></small>",
			"live": true,
			"url": "http://high45.com",
			"extra": ""
		},
		{
			"id": "kibi",
			"title": "Kibi",
			"description": "Social application dedicated to happiness instants. <br> <small>Final year project made at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> <br> with <a href=\"https://www.linkedin.com/pub/alexandre-pav%C3%A9-martinot/35/852/207\" target=\"_blank\">Alexandre Pavé-Martinot</a>, <a href=\"https://www.linkedin.com/pub/olivia-friedrich/61/217/141\" target=\"_blank\">Olivia Friedrich</a> and <a href=\"http://damienseguin.me/\" target=\"_blank\">Damien Seguin</a> </small>",
			"live": false
		},
		{
			"id": "pabloscope",
			"title": "Pabloscope",
			"description": "Mobile app for the reopening of the Picasso Museum in Paris. <br> <small>made at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> with <a href=\"http://louisansa.com/\" target=\"_blank\">Louis Ansa</a>, <a href=\"http://alexiadupredoan.free.fr/\" target=\"_blank\">Alexia Dupré-Doàn</a> and <a href=\"https://www.behance.net/crys9\" target=\"_blank\">Christophe Massolin</a></small>",
			"live": false
		},
		{
			"id": "plug",
			"title": "PLUG",
			"description": "Collaborative musical installation designed for families visiting <a href=\"http://lecube.com/\" target=\"_blank\">Le Cube</a>. <br> <small>First year project made at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> with <a href=\"http://artsime.com/\" target=\"_blank\">Siméon Artamonov</a></small>",
			"live": false
		},
		{
			"id": "citroen",
			"title": "Citröen C-Elysée",
			"description": "Front-end development. <br> <small>made at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a> in collaboration with <a href=\"https://fr.linkedin.com/in/yannick-eustache-99547050\" target=\"_blank\">Yannick Eustache</a></small>",
			"live": false,
			"no_details": true
		},
		{
			"title": "Ferrari",
			"description": "Front development of media modules. <br> <small>made at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a></small>",
			"live": false,
			"no_details": true
		}
	],
	"experience": [
		{
			"date": "12/16 — now",
			"description": "Freelance front-end developer",
			"location": "Paris"
		},
		{
			"date": "11/14 — 11/16",
			"description": "Front-end developer<br> at <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a>",
			"location": "Amsterdam"
		},
		{
			"date": "09/12 — 08/14",
			"description": "Apprentice web developer<br> at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a>",
			"location": "Paris"
		}
	],
	"education": [
		{
			"date": "09/12&nbsp;-&nbsp;06/14",
			"title": "Gobelins, CRMA",
			"description": "Multimedia design and production"
		},
		{
			"date": "09/11&nbsp;-&nbsp;06/12",
			"title": "Paris 13, LP CIWM",
			"description": ""
		},
		{
			"date": "09/09&nbsp;-&nbsp;06/11",
			"title": "IUT Champs, DUT SRC",
			"description": ""
		}
	],
	"about": "After 2 years abroad working for <a href=\"http://buildinamsterdam.com\" target=\"_blank\">Build in Amsterdam</a>, I’m now back in Paris and available for freelance work as Front-end developer.<br> Before this, I had the chance to work at <a href=\"http://bigyouth.fr\" target=\"_blank\">Big Youth</a> in apprenticeship while studying at <a href=\"http://gobelins.fr\" target=\"_blank\">Gobelins</a> in Paris.",
	"links": [
		{
			"url": "mailto:kolin.w@gmail.com",
			"label": "kolin.w@gmail.com"
		},
		{
			"url": "http://twitter.com/kolin_w",
			"label": "Twitter"
		},
		{
			"url": "https://www.linkedin.com/in/kolin-weidmann-77963664/",
			"label": "LinkedIn"
		},
		{
			"url": "http://instagram.com/kolin_w",
			"label": "Instagram"
		}
	],
	"modals": {
		"jason": {
			"id": "jason",
			"title": "Jason Yan Francis",
			"sections": [
				{
					"type": "video",
					"url": "jasonyanfrancis.mp4"
				}
			]
		},
		"desperados": {
			"id": "desperados",
			"title": "Desperados FuturEdition",
			"sections": [
				{
					"type": "video",
					"url": "futuredition.mp4"
				}
			]
		},
		"cantorfineart": {
			"id": "cantorfineart",
			"title": "Cantor Fine Arts",
			"sections": [
				{
					"type": "image",
					"url": "screen1.jpg"
				}
			]
		},
		"cultcheers": {
			"id": "cultcheers",
			"title": "Cultcheers",
			"description": "Colorful landing page for this startup launching a new concept of informal cultural meetups at home.",
			"sections": [
				{
					"type": "image",
					"url": "screen1.jpg",
					"caption": ""
				},
				{
					"type": "video",
					"url": "loop1.mp4",
					"caption": "Smooth scroll and canvas text masked animations"
				}
			]
		},
		"newfysic": {
			"id": "newfysic",
			"title": "NewFysic",
			"description": "Dashboard application and brand/e-commerce website for the slimming method clients. ",
			"sections": [
				{
					"type": "text",
					"content": "<p>Clients of the slimming method get access to an online tool to track their improvements and manage their treatment on a day to day basis.</p>"
				},
				{
					"type": "image",
					"url": "screen1.jpg",
					"caption": "The body measurement dashboard gives them a quickview of their achievement and the goal to reach."
				},
				{
					"type": "image",
					"url": "screen2.jpg",
					"caption": "Their personal diet calendar mixes their appointments with the coach, their food planning, and activities related to the slimming process."
				},
				{
					"type": "image",
					"url": "screen4.jpg",
					"caption": "Recipes can be added directly to the calendar and to their groceries list. It gives them a visibility of what is needed per recipe or overall."
				},
				{
					"type": "image",
					"url": "screen3.jpg",
					"caption": "A logbook if offered to share their journey during the program."
				},
				{
					"type": "image",
					"url": "screen5.jpg",
					"caption": "Quick re-order enables a faster shopping experience."
				}
			]
		},
		"kibi": {
			"id": "kibi",
			"title": "Kibi",
			"description": "Social application dedicated to happiness instants.",
			"sections": [
				{
					"type": "image",
					"url": "1_gif_intro.gif"
				},
				{
					"type": "text",
					"content": "<p>Share these moments with everyone around and allow them to join you. Build stop-motion of these moments by adding your 'kibi' on another one.<br> Make it fun !</p>"
				},
				{
					"type": "video",
					"poster": "2_teaser_cover.jpg",
					"urls": {
						"mp4": "2_teaser.mp4",
						"webm": "2_teaser.webm"
					},
					"caption": "Teaser"
				},
				{
					"type": "text",
					"content": "<p>The app was designed for an iPhone 5 running iOS 7.<br> It was built using Storyboard for the user journey, Cocoapods to manage dependencies like WhirlyGlobe for the main globe navigation, Mapbox for the local map, GPUImage for image capture and manipulation, Parse SDK for the backend communication. Parse is also our media storage and push notifications.</p>"
				},
				{
					"type": "video",
					"poster": "5_screen_cover.jpg",
					"vertical": true,
					"urls": {
						"mp4": "5_screen.mp4",
						"webm": "5_screen.webm"
					},
					"caption": "Screencap of the iOs app"
				},
				{
					"type": "video",
					"poster": "4_rendu_cover.jpg",
					"urls": {
						"mp4": "4_rendu.mp4",
						"webm": "4_rendu.webm"
					},
					"caption": "Examples of kibis"
				},
				{
					"type": "video",
					"poster": "6_makingof_cover.jpg",
					"urls": {
						"mp4": "6_makingof.mp4",
						"webm": "6_makingof.webm"
					},
					"caption": "Making of the teaser"
				},
				{
					"type": "text",
					"content": "<p><a href=\"/static/kibi/kibi_en.pdf\" target=\"_blank\">Read the presentation</a><sup>PDF</sup> we made</p>"
				}
			]
		},
		"pabloscope": {
			"id": "pabloscope",
			"title": "Pabloscope",
			"description": "iOS 7 native application for the reopening of the Picasso Museum in Paris.",
			"sections": [
				{
					"type": "image",
					"url": "0_intro.jpg",
					"caption": "After 5 years closed for renovation, the museum asked for a promotional application for its reopening. We had 3 months to find our idea and produce it.<br> Our response \"Pabloscope\" won the picasso jury approval."
				},
				{
					"type": "embed",
					"content": "<iframe src=\"https://player.vimeo.com/video/104795610\" width=\"640\" height=\"360\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
				},
				{
					"type": "image",
					"url": "2_inspi.jpg"
				},
				{
					"type": "image",
					"url": "3_end.jpg"
				},
				{
					"type": "text",
					"content": "<p><a href=\"/static/pabloscope/picasso_en.pdf\" target=\"_blank\">Read the presentation</a><sup>PDF</sup> we made</p>"
				}
			]
		},
		"plug": {
			"id": "plug",
			"title": "Plug",
			"description": "Collaborative musical experience designed for families visiting Le Cube.",
			"sections": [
				{
					"type": "image",
					"url": "1_intro.jpg",
					"caption": "With their smartphones, visitors can interact with a \"totem\". Up to 4 of them can connect to the web-app and play music together. They will hear and see their place in the orchestra through the totem."
				},
				{
					"type": "embed",
					"content": "<iframe src=\"https://player.vimeo.com/video/69433394\" width=\"640\" height=\"360\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"
				},
				{
					"type": "image",
					"url": "3_slide_1.jpg"
				},
				{
					"type": "image",
					"url": "3_slide_2.jpg"
				},
				{
					"type": "image",
					"url": "3_slide_3.jpg"
				},
				{
					"type": "image",
					"url": "3_slide_4.jpg"
				},
				{
					"type": "text",
					"content": "<p>To play with PLUG, visitors have to connect their smartphones to our wifi and visit our webpage. They will get the webapp, which communicates to our Node server through websockets. This server then transmit messages to Max MSP through the OSC protocol. Max MSP will receive all visitor's actions and play audio accordingly. In the same time it will direct the arduino to light up the totem in accordance with the sound it produces.</p>"
				},
				{
					"type": "video",
					"url": "3_makingof.mp4",
					"caption": "Demo of the Arduino controlling the led strip"
				},
				{
					"type": "image",
					"url": "4_slide_3.jpg",
					"caption": "Dashboard of the Max MSP patch"
				},
				{
					"type": "image",
					"url": "4_slide_1.jpg"
				},
				{
					"type": "image",
					"url": "4_slide_2.jpg",
					"caption": "Mock-ups of the web-app"
				},
				{
					"type": "text",
					"content": "<p>Exhibition: <br> Le Cube, 22/06/13<br> Happy Cube Day, 21/09/13<br> DIY Days, ESCP Europe Paris, 22/03/14</p>"
				}
			]
		},
		"cloudfaves": {
			"id": "cloudfaves",
			"title": "Cloudfaves",
			"description": "Enhanced soundcloud player.",
			"sections": [
				{
					"type": "image",
					"url": "1_slide.jpg"
				},
				{
					"type": "text",
					"content": "<p>Soundcloud webapp demo with useful added features such as: one page only, no infinite scroll, favorites search, manageable queue. <br> Personal project driven by my needs as a heavy user of Soundcloud. It was a chance to play with their API, and test Backbone Marionette's framework.</p>"
				},
				{
					"type": "image",
					"url": "2_slide.jpg"
				},
				{
					"type": "text",
					"content": "<p><a href=\"http://sound.kolin.fr/beta/\" target=\"_blank\">Try the demo here</a><sup>↙</sup></p>"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/data.json
// module id = 39
// module chunks = 1